module.exports = __webpack_public_path__ + "static/media/offers.1e79c7ee.svg";